'use client';

import { useEffect, useRef, useState } from 'react';

export default function ReadingProgressBar() {
  const [progress, setProgress] = useState(0); // 0..1; SSR renders 0 (invisible)
  const rafId = useRef(0);

  useEffect(() => {
    const compute = () => {
      rafId.current = 0;
      const docEl = document.documentElement;
      const max = docEl.scrollHeight - window.innerHeight;
      const p = max > 0 ? (window.scrollY || docEl.scrollTop) / max : 0;
      setProgress(Math.min(1, Math.max(0, p)));
    };
    const onScroll = () => {
      if (rafId.current) return;
      rafId.current = requestAnimationFrame(compute);
    };
    compute();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      className="blog-reading-progress"
      style={{
        position: 'fixed',
        top: 'var(--space-72)',
        left: 0,
        height: '4px',
        width: `${progress * 100}%`,
        background: 'var(--gold)',
        zIndex: 99,
        pointerEvents: 'none',
        willChange: 'width',
      }}
    />
  );
}
